import { connect } from 'react-redux';
import Chart from '../../components/Inputs/Chart';

export default connect()(Chart);
